<template>
  <footer />
</template>
<script>
export default { name: 'FooterSection' };
</script>